<template>
  <div class="light-dark">
    <v-menu v-model="menu" offset-y max-width="350" transition="scale-transition" close-on-content-click
      :close-on-click="false">
      <template #activator="{ props }">
        <v-btn v-bind="props" icon variant="tonals" class="position-relative " aria-label="Notifications">
          <span class="material-symbols-outlined">notifications</span>
          <v-badge :content="count" overlap class="position-absolute top-0 start-100 translate-middle " />
        </v-btn>
      </template>

      <v-card style="width: 350px;">
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="fw-semibold text-secondary" style="font-size: 1rem;">
            Notifications
            <span class="fw-normal text-body" style="font-size: 0.875rem;">
              ({{ count }})
            </span>
          </span>
          <v-btn variant="text" size="small" class="text-primary" @click="readAll">
            Read All
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-list style="max-height: 217px; overflow-y: auto;" dense>
          <v-list-item v-for="notification in notifications" :key="notification.id"
            :class="{ 'unseen': !notification.is_read }">
            <v-list-item-content>
              <v-list-item-title>
                <strong>{{ notification.title }}</strong>
              </v-list-item-title>
              <v-list-item-subtitle v-html="notification.message"></v-list-item-subtitle>
              <v-list-item-subtitle class="fs-13 text-secondary">
                {{ formatDate(notification.created_at) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="notifications.length === 0">
            No notifications found.
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <!-- <v-card-actions class="justify-center">
          <RouterLink to="/notification" class="text-primary fw-medium" style="text-decoration: none;"
            @click="menu = false">
            See All Notifications
          </RouterLink>
        </v-card-actions> -->
      </v-card>
    </v-menu>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { fetchNotificationsWithCount,readAllNotification,readNotification } from "@/services/apiServices";

const menu = ref(false);
const notifications = ref([]);
const count = ref(0);

function formatDate(dateString) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

const readAll = async () => {
  // console.log("Read all notifications");
  try {
    await readAllNotification();
    // notifications.value.forEach((notification) => {
    //   notification.is_read = true;
    // });
    // count.value = 0;
    // console.log("All notifications marked as read");
  } catch (error) {
    console.error("Error marking all notifications as read:", error);
  }
};


const readSingleNotification = async (notificationId) => {
  try {
    await readNotification(notificationId);
    const notification = notifications.value.find(n => n.id === notificationId);
    if (notification) {
      notification.is_read = true;
      count.value--;
    }
  } catch (error) {
    console.error("Error marking notification as read:", error);
  }
};

let intervalId = null;
onMounted(() => {
  const fetchData = async () => {
    try {
      const response = await fetchNotificationsWithCount();
      notifications.value = response.list || [];
      count.value = response.count?.unread_count || 0;
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  fetchData();

  intervalId = setInterval(fetchData, 95000); // fetch every 15 seconds
});

onUnmounted(() => {
  clearInterval(intervalId);
});



watch(
  notifications,
  (newVal) => {
    count.value = newVal.filter((n) => !n.is_read).length;
  },
  { immediate: true }
);
</script>

<style scoped>
.v-list-item {
  padding-top: 8px;
  padding-bottom: 8px;
}

.fs-13 {
  font-size: 13px;
}

.fw-semibold {
  font-weight: 600;
}

.fw-normal {
  font-weight: 400;
}

.text-primary {
  color: #1976d2 !important;
}

.text-secondary {
  color: #6c757d !important;
}

.position-relative {
  position: relative;
}
</style>
